import { render, staticRenderFns } from "./bianminAdd.vue?vue&type=template&id=3660e2bc&scoped=true"
import script from "./bianminAdd.vue?vue&type=script&lang=js"
export * from "./bianminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660e2bc",
  null
  
)

export default component.exports